import { render, staticRenderFns } from "./losePage.vue?vue&type=template&id=d9386876&scoped=true"
import script from "./losePage.vue?vue&type=script&lang=js"
export * from "./losePage.vue?vue&type=script&lang=js"
import style0 from "./losePage.vue?vue&type=style&index=0&id=d9386876&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9386876",
  null
  
)

export default component.exports